<template>
    <div class="skeleton"></div>
</template>

<script>
import VueTypes from 'vue-types';

export default {
    name: 'MySkeleton',
    props: {
        width: VueTypes.number,
        height: VueTypes.number,
        borderRadius: VueTypes.number.def(0)
    },
    data() {
        return {
            isFetched: false
        };
    }
};
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
